// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".collapsePanelToggleLabel__2PX57{font-size:12px;font-weight:bold;font-family:'TTNORMSPRO';text-transform:uppercase;letter-spacing:1px;color:black}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/components/CollapsePanelMobile.module.scss"],"names":[],"mappings":"AAAA,iCACE,cAAe,CACf,gBAAiB,CACjB,wBAAyB,CACzB,wBAAyB,CACzB,kBAAmB,CACnB,WAAY","file":"CollapsePanelMobile.module.scss","sourcesContent":[".collapsePanelToggleLabel {\n  font-size: 12px;\n  font-weight: bold;\n  font-family: 'TTNORMSPRO';\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: black;\n}\n"]}]);
// Exports
exports.locals = {
	"collapsePanelToggleLabel": "collapsePanelToggleLabel__2PX57"
};
module.exports = exports;
